import {  useState } from "react";
import { useTranslation } from "react-i18next";

import CreateRecordButtonLayout from "../layout/CreateRecordButtonLayout";
import TkProcessSelectionDialog from './../dialogTypes/TkProcessSelectionDialog';

function TkProcessSelectionButton(props) {
    
    const { t } = useTranslation();

    const {
        id,
        refresh,
        onSuccess,
        selectItems,
        orderBuyerDetailByProcessGrid,
        orderBuyerDetailByProcessApi,
        ...others
    } = props;


    const [open, setOpen] = useState(false);

    const onOpen = () => {
        setOpen(true);
    };

    const onClose = () => {
        setOpen(false);
    };

    const onCreateSuccess = (msg) => {
        if (onSuccess) {
            onSuccess(msg);
        }

        if(orderBuyerDetailByProcessApi) {

            orderBuyerDetailByProcessApi.refresh();        }
    };

    return (
        <>
            <CreateRecordButtonLayout id={id + "create-button"} onClick={onOpen} createButtonName={"processSelection"}{...others}/>
            <TkProcessSelectionDialog
                id={id + "create-dialog"}
                formId={id + "create-form"}
                title={t(`dialog.title.processSelection.create`)}
                open={open}
                selectItems = {selectItems}
                orderBuyerDetailByProcessGrid = {orderBuyerDetailByProcessGrid}
                
                onClose={onClose}
                onSuccess={onCreateSuccess}
            />
        </>
    );
}

export default TkProcessSelectionButton;
